import { render, staticRenderFns } from "./PaperworkSetDetailForm.vue?vue&type=template&id=1f77a718&"
import script from "./PaperworkSetDetailForm.vue?vue&type=script&lang=js&"
export * from "./PaperworkSetDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports